export interface LoginForm {
  email: string;
  password: string;
}

export interface ICheckboxTermosUsoPIE {
  showCheckbox: boolean;
  isChecked: boolean;
}

export interface LoginContextProps {
  canCheckLogin: boolean;
  checkboxTerms: ICheckboxTermosUsoPIE;
  isLoading: boolean;
  loginData: LoginForm;
  redirectURL: string;
  showTermsUse: boolean;
  errorMessage: IErrorMessageLogin | IErrorMessagePassword | '';
  setCanCheckLogin: (update: boolean) => void;
  setCheckboxTerms: (checkbox: ICheckboxTermosUsoPIE) => void;
  setIsLoading: (loading: boolean) => void;
  setLoginData: (login: LoginForm) => void;
  setRedirectURL: (url: string) => void;
  setShowTermsUse: (show: boolean) => void;
  setErrorMessage: React.Dispatch<React.SetStateAction<IErrorMessageLogin | IErrorMessagePassword | ''>>;
  redirectToLogin: (event?) => void;
  keys: string[];
}

export interface IframeUpdate {
  target: any;
  hasUpdate: boolean;
}
export interface CompleteUpdate {
  target: any;
  message: boolean;
}

export enum IErrorMessageLogin {
  EMAIL_FORMATO_INVALIDO = 'Você precisa preencher corretamente este campo',
  INFOS_INCORRETAS = 'E-mail ou senha incorretos',
  ERRO_SERVICO = 'Ops! Tem alguma coisa errada! Contate o suporte: suporte@fundacred.org.br',
  EMAIL_NAO_CADASTRADO = 'Credenciais inválidas.',
  RECAPTCHA_ERRO_SERVICO = 'Recaptcha indisponível. Se o erro persistir, contate o suporte: suporte@fundacred.org.br',
  RECAPTCHA_INVALIDO = 'Recaptcha inválido. Por favor, tente novamente em alguns minutos.',
  USUARIO_INATIVO = 'Ops! Seu usuário foi inativado após 12 meses sem acesso. <br/>Para reativação entre em contato com <strong><a style="cursor: text">suporte@fundacred.org.br</a><strong>.',
}

export enum IErrorMessagePassword {
  SENHA_INVALIDA = 'A senha deve cumprir os requisitos, tente de novo',
  SENHA_NAO_CONFIRMADA = 'Os dois campos precisam ser iguais, tente de novo',
  ERRO_LINK_EXPIRADO = 'O link de solicitação de redefinição de senha expirou.',
  ERRO_SERVICO = 'Ops! Tem alguma coisa errada! Contate o suporte: suporte@fundacred.org.br',
}

export enum IErrorMessageApi {
  DADOS_INVALIDOS = 'Usuário ou senha incorretos!',
  TOKEN_RECAPTCHA_INVALIDO = 'Recaptcha inválido',
  USUARIO_INATIVO = 'Usuário inativo!',
}

export enum EnumScreenName {
  TELA_LOGIN = 'Tela-login',
  TELA_RECUPERAR_SENHA = 'tela-recuperar-senha',
  TELA_LINK_ENVIADO = 'tela-link-enviado',
  TELA_REDEFINICAO_SENHA = 'tela-redefinicao-senha',
}

export const errorMap: Record<string, IErrorMessageLogin> = {
  [IErrorMessageApi.DADOS_INVALIDOS]: IErrorMessageLogin.INFOS_INCORRETAS,
  [IErrorMessageApi.TOKEN_RECAPTCHA_INVALIDO]: IErrorMessageLogin.RECAPTCHA_INVALIDO,
  [IErrorMessageApi.USUARIO_INATIVO]: IErrorMessageLogin.USUARIO_INATIVO,
}
